<template>
    <TheMobileTabBar v-if="isMobile" />
    <section v-else>
        <footer>
            <p>
                &copy; MGSG {{ year }}
                <span class="app-version">App Version {{ gitCommit }}</span>
            </p>
        </footer>
    </section>
</template>

<script>
import TheMobileTabBar from './TheMobileTabBar.vue';
import { isMobileBuild } from '@/utils/platform';

export default {
    components: { TheMobileTabBar },
    data() {
        return {
            year: new Date().getFullYear(),
            gitCommit: process.env.VUE_APP_GIT_COMMIT || 'dev',
        };
    },
    computed: {
        isMobile() {
            return isMobileBuild();
        },
    },
};
</script>

<style scoped>
    section {
        position: fixed;
        width: 100%;
        left: 0;
        bottom: 0;
        z-index: 1030;
        display: flex;
        justify-content: center;
        align-items: center;
        flex-direction: row;
        min-height: var(--app-footer-height);
        background-color: #264271;
        color: white;
        flex-shrink: 0;
    }

    section p {
        font-size: 0.6rem;
        margin: 0;
        display: flex;
        justify-content: center;
        align-items: center;
        gap: 0.75rem;
    }

    .app-version {
        font-size: 0.5rem;
        opacity: 0.55;
        font-weight: 400;
    }
</style>
